import { Star, ExternalLink } from "lucide-react";
import { Reveal } from "./Reveal";
import { GOOGLE_REVIEWS_URL, REVIEWS } from "../config/business";

const GoogleMark = () => (
  <svg viewBox="0 0 24 24" className="h-8 w-8" aria-hidden="true">
    <path fill="#4285F4" d="M23.5 12.27c0-.85-.08-1.66-.22-2.45H12v4.64h6.45a5.52 5.52 0 0 1-2.4 3.62v3h3.88c2.27-2.09 3.57-5.17 3.57-8.81z" />
    <path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.91l-3.88-3c-1.07.72-2.44 1.15-4.06 1.15-3.12 0-5.77-2.11-6.71-4.95H1.29v3.1A12 12 0 0 0 12 24z" />
    <path fill="#FBBC05" d="M5.29 14.29A7.2 7.2 0 0 1 4.91 12c0-.8.14-1.57.38-2.29v-3.1H1.29a12 12 0 0 0 0 10.78l4-3.1z" />
    <path fill="#EA4335" d="M12 4.76c1.76 0 3.34.6 4.58 1.8l3.44-3.44A11.98 11.98 0 0 0 12 0 12 12 0 0 0 1.29 6.61l4 3.1c.94-2.84 3.59-4.95 6.71-4.95z" />
  </svg>
);

const BlueStars = ({ count = 5, label }) => (
  <div className="flex gap-1" aria-label={label}>
    {[...Array(count)].map((_, i) => (
      <Star key={i} className="h-5 w-5 fill-[#00AEEF] text-[#00AEEF]" />
    ))}
  </div>
);

export const Reviews = () => (
  <section id="reviews" className="bg-[#111214] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="text-center">
        <p className="font-display text-xs font-bold uppercase tracking-[0.3em] text-[#00AEEF] sm:text-sm">
          Customer Feedback
        </p>
        <h2 className="font-display mx-auto mt-3 max-w-3xl text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-[#f4f4f2] sm:text-4xl lg:text-5xl">
          Trusted by Mississauga Drivers
        </h2>
        <div className="mt-5 flex justify-center">
          <BlueStars label="Rated on Google" />
        </div>
      </Reveal>

      {REVIEWS.length === 0 ? (
        <Reveal delay={0.1}>
          <div className="mx-auto mt-12 flex max-w-3xl flex-col items-center gap-6 border border-white/10 bg-[#17181c] p-10 text-center lg:p-14">
            <div className="flex items-center gap-4">
              <GoogleMark />
              <p className="font-display text-2xl font-bold uppercase leading-none text-[#f4f4f2]">
                Google Reviews
              </p>
            </div>
            <p className="max-w-xl leading-relaxed text-[#a6a9b1]">
              Our reputation is built one honest repair at a time. See what
              drivers across Mississauga and the GTA say about their experience
              with Auto Trust Centre on Google.
            </p>
            <a
              data-testid="reviews-google-button"
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Read Our Google Reviews
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>
        </Reveal>
      ) : (
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={i * 0.08} className="h-full">
              <figure className="flex h-full flex-col border border-white/10 bg-[#17181c] p-7">
                <BlueStars count={r.rating} label={`${r.rating} out of 5 stars`} />
                <blockquote className="mt-4 flex-1 leading-relaxed text-[#c9ccd2]">
                  "{r.text}"
                </blockquote>
                <figcaption className="mt-5 border-t border-white/10 pt-4">
                  <p className="font-display font-bold uppercase text-[#f4f4f2]">{r.name}</p>
                  <p className="text-sm text-[#6b6e76]">{r.date} · Google</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  </section>
);
